<template>
  <Datepicker
    v-model="modelValue"
    :placeholder="placeholder"
    :format="format"
    :clearable="clearable"
    :autoApply="autoApply"
    :disabled="disabled"
    calendarCellClassName="dp-custom-cell"
  />
</template>

<script>
import { ref, watch, onMounted } from "vue";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";

export default {
  name: "VueDatePicker",
  components: { Datepicker },
  props: {
    dateValue: {
      default: null,
      type: [String, Date, Object],
      required: false,
    },
    placeholder: {
      default: "",
      type: String,
      required: false,
    },
    format: {
      default: null,
      type: String,
      required: false,
    },
    clearable: {
      default: true,
      type: Boolean,
      required: false,
    },
    autoApply: {
      default: true,
      type: Boolean,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  setup(props, context) {
    let modelValue = ref(props.dateValue);
    const format = ref(props.format);

    watch(modelValue, (newVal) => {
      context.emit("update:modelValue", newVal);
    });

    return {
      modelValue,
      format,
    };
  },
};
</script>

<style lang="scss">
.dp-custom-cell {
  border-radius: 50%;
}
.dp__input {
  font-size: 0.875rem;
}
.dp__menu {
  font-size: 0.875rem;
}
</style>